/**
 * botIgnite — F execute vs low-HP enemy champions (FID-BOT-22).
 *
 * Pure JS — no Three.js, no DOM.
 */

import { canCastSlot } from './botCast.js';

export const BOT_IGNITE_EXECUTE_HP = 0.18;
export const BOT_IGNITE_RANGE = 6;

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

function isEnemyChampion(entity, team) {
  if (!entity || entity.isDead) return false;
  if (entity.team === team) return false;
  return entity.type === 'champion';
}

function hasIgniteOnF(bot) {
  const f = String(bot?.spellF || bot?.spell2 || 'ignite').toLowerCase();
  return f === 'ignite';
}

export function pickIgniteExecuteTarget(bot, enemies = [], range = BOT_IGNITE_RANGE) {
  if (!bot || !(range > 0)) return null;
  let best = null;
  let bestRatio = Infinity;
  for (const enemy of enemies) {
    if (!isEnemyChampion(enemy, bot.team)) continue;
    const dist = Math.hypot(enemy.x - bot.x, entityZ(enemy) - entityZ(bot));
    if (dist > range) continue;
    const ratio = enemy.hp / (enemy.maxHp || 1);
    if (ratio >= BOT_IGNITE_EXECUTE_HP) continue;
    if (ratio < bestRatio) {
      bestRatio = ratio;
      best = enemy;
    }
  }
  return best;
}

export function botIgniteDecision(bot, enemies = []) {
  if (!hasIgniteOnF(bot) || !canCastSlot(bot, 'F')) return null;
  const target = pickIgniteExecuteTarget(bot, enemies);
  if (!target) return null;
  return {
    action: 'cast',
    slot: 'F',
    targetEntity: target,
    targetX: target.x,
    targetZ: entityZ(target)
  };
}
